<div class="flex justify-center">
  <div
    [class]="`flex justify-center items-center ${bgClass()}-50 p-lg rounded-full mb-xl`">
    @switch (status()) {
      @case ('error') {
        <lib-close-square-icon [iconClass]="'size-8 text-destructive-500'" />
      }
      @default {
        <lib-info-border-icon [iconClass]="'size-8 text-primary-500'" />
      }
    }
  </div>
</div>

@if (title()) {
  <p class="text-lg text-center font-medium mb-sm text-neutral-900">
    {{ title() }}
  </p>
}

@if (description()) {
  <p class="text-sm text-neutral-500 text-center mb-4xl">
    {{ description() }}
  </p>
}

<div class="flex flex-col gap-md text-base font-medium">
  @let confirm = confirmButton();
  @if (confirm) {
    <button
      (click)="confirm.action()"
      [class.opacity-30]="disable()"
      [disabled]="disable()"
      [class]="`py-sm rounded-md text-white text-base cursor-pointer ${bgClass()}-500`">
      {{ confirm.label }}
    </button>
  }

  <button
    (click)="close()"
    [class.opacity-30]="disable()"
    [disabled]="disable()"
    class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
    {{
      cancelButton()
        ? cancelButton()
        : ('confirmation_modal_cancel_button_label' | transloco)
    }}
  </button>
</div>
